import React from "react";
import sortBy from "lodash/sortBy";
import Link from "next/link";

import { ReportedOptions } from "@/custom-types/StrainList";
import { StrainTag } from "@/custom-types/StrainTags";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { useEventTracker } from "@/hooks/useEventTracker";

import TrackImpression from "@/components/TrackImpression";

type Props = {
  reportedOptions: ReportedOptions;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  [x: string]: any;
};

const ExploreOtherCategories = ({ reportedOptions, ...others }: Props) => {
  reportedOptions.conditions = sortBy(reportedOptions.conditions, [
    "displayName",
  ]);

  const countryCode = useDomainCountryCode();
  const { publishEvent } = useEventTracker();

  return (
    <TrackImpression category="Playlist" label="Other Categories" {...others}>
      <h2 className="text-md mb-md">All strains</h2>
      <div className="text-sm">
        {reportedOptions["categories"] &&
          renderCategory(
            "Strain types",
            "category",
            [
              ...reportedOptions["categories"],
              {
                displayName: "view all strains",
                slug: "/strains",
              },
            ],
            publishEvent,
          )}
        {reportedOptions["effects"] &&
          renderCategory(
            "Strains by feeling*",
            "effect",
            reportedOptions["effects"],
            publishEvent,
          )}
        {reportedOptions["conditions"] &&
          renderCategory(
            "Strains that may help with*",
            "condition",
            reportedOptions["conditions"],
            publishEvent,
          )}
        {reportedOptions["flavors"] &&
          renderCategory(
            countryCode === "CA"
              ? "Strains by flavour and aroma*"
              : "Strains by flavor and aroma*",
            "flavor",
            reportedOptions["flavors"],
            publishEvent,
          )}
        {reportedOptions["terpenes"] &&
          renderCategory(
            "Strains by terpene",
            "terpene",
            reportedOptions["terpenes"],
            publishEvent,
          )}
      </div>
    </TrackImpression>
  );
};

const renderCategory = (
  title: string,
  category: string,
  options: StrainTag[],
  publishEvent: ReturnType<typeof useEventTracker>["publishEvent"],
) => {
  return (
    <div key={category} className="mb-xl">
      <h3 className="heading--xs mb-sm uppercase">{title}</h3>
      <div className="columns-2 md:columns-4 hyphens-auto">
        {options.map((tag) => (
          <Link
            prefetch={false}
            key={tag.slug}
            href={
              tag.displayName === "view all strains"
                ? `${tag.slug}`
                : `/strains/lists/${encodeURIComponent(
                    category,
                  )}/${encodeURIComponent(tag.slug)}`
            }
            className="block underline mb-lg capitalize"
            onClick={() => {
              publishEvent({
                action: "Click",
                category: "Hub",
                label: `${tag.displayName}`,
              });
            }}
          >
            {tag.displayName}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ExploreOtherCategories;
